import { render, staticRenderFns } from "./fenye.vue?vue&type=template&id=cae641ec&scoped=true"
import script from "./fenye.vue?vue&type=script&lang=js"
export * from "./fenye.vue?vue&type=script&lang=js"
import style0 from "./fenye.vue?vue&type=style&index=0&id=cae641ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae641ec",
  null
  
)

export default component.exports